// CB:BEGIN ui-empty-state
import React from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  icon?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, description, action, icon }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 24px',
      textAlign: 'center',
      gap: 12,
    }}
  >
    {icon && (
      <div style={{ color: '#d1d5db', marginBottom: 4 }}>
        {icon}
      </div>
    )}
    {!icon && (
      <svg width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="#d1d5db" strokeWidth={1.5} style={{ marginBottom: 4 }}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    )}
    <div style={{ fontSize: 15, fontWeight: 600, color: '#374151' }}>{title}</div>
    {description && (
      <div style={{ fontSize: 13, color: '#9ca3af', maxWidth: 360, lineHeight: 1.6 }}>{description}</div>
    )}
    {action && (
      <button
        onClick={action.onClick}
        style={{
          marginTop: 4,
          padding: '8px 20px',
          background: '#123c3b',
          color: '#fff',
          border: 'none',
          borderRadius: 8,
          fontSize: 13,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        {action.label}
      </button>
    )}
  </div>
);

export default EmptyState;
// CB:END ui-empty-state
